import * as R from 'ramda'

export default R.either(R.isEmpty, R.isNil)
